export const defaultImage = () => {
    return "data:image/png;base64,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";
};

export const preparePhone = (phonenumber) => {
    return '+' + phonenumber.replace(/\s/g, '');
};

export const parseJobStatus = (remote_job) => {
    if (!remote_job) {
        return;
    }
    let photo = '';
    if (typeof remote_job.photos !== "undefined") {
        if (remote_job.photos !== null) {
            try {
                let photos = JSON.parse(remote_job.photos);
                if (typeof photos === "object") {
                    photo = photos[0];
                }
            } catch(Exception) {}
        }
    }
    let job = {
        job_type: remote_job.servicetype,
        image: photo,
        make: '',
        model: '',
        year: '',
        color: '',
        address: {
            address: remote_job.address,
            apartment: '',
            city: '',
            zip: '',
            state: '',
            additionalNote: '',
            name: remote_job.name,
            firstname: remote_job.firstname,
            lastname: remote_job.lastname
        },
        payment_method: remote_job.payment_method,
        payment_data: null,
        numberOfLocks: '',
        orderDescription: '',
        residentialSwitch: '',
        ignDoorSwitch: '',
        lcSwitch: '',
        lcrSwitch: '',
        lockType: '',
        keyType: ''
    }
    return job;
};

export const parseJobThankyou = (remote_job) => {
    let job = {
        job_type: remote_job.servicetype,
        image: (remote_job.photos ? remote_job.photos[0] : ''),
        make: '',
        model: '',
        year: '',
        color: '',
        address: {
            address: remote_job.address,
            apartment: '',
            city: '',
            zip: '',
            state: '',
            additionalNote: '',
            name: remote_job.name,
            firstname: remote_job.firstname,
            lastname: remote_job.lastname
        },
        payment_method: remote_job.payment_method,
        payment_data: null,
        numberOfLocks: '',
        orderDescription: '',
        residentialSwitch: '',
        ignDoorSwitch: '',
        lcSwitch: '',
        lcrSwitch: '',
        lockType: '',
        keyType: ''
    }
    return job;
}

export const parseJob = (phonenumber, local_job) => {
    let job = {
        name: local_job.address.name,
        firstname: local_job.address.firstname,
        lastname: local_job.address.lastname,
        title: '',
        company: '',
        description: local_job.description,
        country: 'US',
        zip: local_job.address.zip,
        location_lng: local_job.address.location_lng,
        location_lat: local_job.address.location_lat,
        city: local_job.address.city,
        state: local_job.address.state,
        address: local_job.address.address + ', ' + local_job.address.city + ', ' + local_job.address.state + ' ' + local_job.address.zip,
        app: '',
        source: 1,
        note: '',
        email: local_job.email,
        phonenumber: phonenumber,
        servicetype: local_job.job_type,
        type: getJobType(local_job.job_type),
        payment_method: local_job.payment_method,
        image: local_job.image
    };
    return job;
};

export const getTypeTextGlobal = (job_type) => {
    let text = '';
    switch (job_type) {
        case 'car':
            text = 'Car Lockout';
            break;
        case 'trunk':
            text = 'Trunk Lockout';
            break;

        case 'house':
            text = 'House Lockout';
            break;

        case 'storage':
            text = 'Storage Unit Lockout';
            break;

        case 'general':
            text = 'General Lockout';
            break;

        case 'changelocks':
            text = 'Change Locks';
            break;

        case 'rekey':
            text = 'Rekey';
            break;

        case 'carkey':
            text = 'Car Key';
            break;

        case 'cardoor':
            text = 'Change Car Door Locks';
            break;

        case 'keyextraction':
            text = 'Key Extraction';
            break;

        case 'key_extraction_from_car':
            text = 'Key Extraction From Car';
            break;

        case 'safe':
            text = 'Safe';
            break;

        case 'panic_bar':
            text = 'Panic Bar (Push Bar)';
            break;
    }
    return text;
}

export const getJobType = (jobtype) => {
    let output = 0;
    switch (jobtype) {
        case 'car':
            output = 1;
            break;
        case 'trunk':
            output = 7;
            break;

        case 'house':
            output = 13;
            break;

        case 'storage':
            output = 18;
            break;

        case 'general':
            output = 23;
            break;

        case 'changelocks':
            output = 24;
            break;

        case 'rekey':
            output = 25;
            break;

        case 'carkey':
            output = 9;
            break;

        case 'cardoor':
            output = 26;
            break;

        case 'keyextraction':
            output = 3;
            break;

        case 'key_extraction_from_car':
            output = 27;
            break;

        case 'safe':
            output = 17;
            break;

        case 'panic_bar':
            output = 28;
            break;
    }
    return output;
}